import { inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {
  ResolveServiceAreaGQL,
} from "graphql.generated";
import { map, exhaustMap, catchError, of, filter, tap } from 'rxjs';

import { showGoogleMapsRouteV2 } from "src/app/utilities/locations.util";

import { JobManuallyAddLocationActions } from "../job-manually-add-location/job-manually-add-location.actions";

import { JobCreateLocationsActions } from "./job-create-locations-state.actions";

export const showGoogleMapsRoute = createEffect((
  actions$ = inject(Actions)
) => {
  return actions$.pipe(
    ofType(JobCreateLocationsActions.showGoogleMapsRouteButtonClicked),
    tap((action) => {
        window.open(
          showGoogleMapsRouteV2(
            (action as any).locations?.start?.selectedLocation?.addressLineOne,
            (action as any).locations?.end?.selectedLocation?.addressLineOne,
          ),
          '_blank',
        )
    }),
  );
}, { functional: true, dispatch: false });

export const resolveServiceAreaAfterLocationAddedManually = createEffect((
  actions$ = inject(Actions),
  resolveServiceAreaGQL = inject(ResolveServiceAreaGQL),
) => {
  return actions$.pipe(
    ofType(JobManuallyAddLocationActions.addLocationButtonClicked),

    filter(({ locationType }) => locationType === 'start'),

    exhaustMap((location) => {
      const {
        streetName,
        streetNumber,
        areaCode,
        city,
        country,
        jurisdiction,
      } = location;

      const addressLineOne = `${streetNumber} ${streetName}, ${city}, ${jurisdiction} ${areaCode}, ${country}`;

      return resolveServiceAreaGQL.fetch({
        areaCode,
        query: addressLineOne,
      }).pipe(
        map((res) =>
          JobCreateLocationsActions.resolveServiceAreaSuccess({
            responseData: res.data.resolveServiceArea
          })
        ),
        catchError((error) =>
          of(JobCreateLocationsActions.resolveServiceAreaError({ error }))
        )
      );
    }),
  );
}, { functional: true, dispatch: true });
